import http from "../../utils/httpClient";

class orderService {
  getOrder = async () => {
    return await http.get("/api/Order/GetOrder?getAll=y");
  };

  getOrderByInvoiceNumber = async (invoiceNumber) => {
    return await http.get(`/api/Order/GetOrder?invoiceNumber=${invoiceNumber}`);
  };

  //Get Shopwise Order By Id
  getShopWiseOrderById = async (shopId) => {
    return await http.get(
      `/api/Seller/GetSellerOrderInfo?shopId=${shopId}&getAll=Y`
    );
  };

  //Filter Date Order By Id
  filterDateOrderById = async (shopId, startDate, endDate) => {
    return await http.get(
      `api/Order/GetShopWiseOrderById?shopId=${shopId}&startDate=${startDate}&endDate=${endDate}&getAll=y`
    );
  };

  // Order Status Type - Start
  getOrderStatusType = async () => {
    return await http.get("/api/Order/GetOrderStatusType");
  };
  createOrUpdateOrderStatusType = async (data) => {
    return await http.post("/api/Order/AddOrEditOrderStatusType", data);
  };
  // Order Status Type - End

  //Order Tracking
  createOrderTracking = async (data) => {
    return await http.post("/api/Order/AddOrEditOrderTracking", data);
  };

  //Order Tracking
  updateShopWiseOrderStatus = async (data) => {
    return await http.post("/", data);
  };

  //Order Tracking
  updateProductWiseOrderStatus = async (data) => {
    return await http.post("/api/Order/AddOrderTracking", data);
  };
  //Order Tracking Cancel
  updateProductWiseCancelOrderStatus = async (data) => {
    return await http.post("/api/Order/AddOrEditCancelProductOrder", data);
  };
  //Order Tracking Return
  updateProductWiseReturnOrderStatus = async (data) => {
    return await http.post("/api/Order/AddOrEditOrderReturn", data);
  };
  //Fetch single order
  fetchSingleOrder = async (id) => {
    return await http.get(
      `/api/Order/GetOrderDetailsById?orderDetailsId=${id}`
    );
  };
  //Fetch status wise order list
  fetchStatusWiseOrderList = async (
    statusId,
    shopId,
    currentPage,
    itemPerPage
  ) => {
    return await http.get(
      `api/Order/GetShopWiseOrderDetailsByTrackingStatus?isActive=Y&status=${statusId}&shopId=${shopId}&currentPage=${currentPage}&itemsPerPage=${itemPerPage}`
    );
  };
  //Get Status Wise Order List Start
  getOrderStatusWise = async (query) => {
    return await http.get(
      `/api/Order/V2/GetOrderByStatusWise`, { params: query }
    );
  };
  //Get Status Wise Order List End

  //Get Status Wise Order Summary Start
  getOrderStatusWiseSummary = async (status, invoice) => {
    return await http.get(
      `/api/Order/GetOrderByStatusWise?invoiceNumber=${invoice}&status=${status}`
    );
  };
  //Get Status Wise Order Summary End

  //Get Shop Wise Order Details Start
  getShopWiseOrderDetails = async (statusName, invoiceNo, orderNo) => {

    return await http.get(
      `/api/Order/V2/GetOrderDetailByStatusWise?orderNo=${invoiceNo}&shopWiseOrderNo=${orderNo}&status=${statusName}`
    );
  };
  //Get Shop Wise Order Details End

  //Get Cancel Orders
  fetchCancelOrder = async (query) => {
    return await http.get(
      `/api/Order/GetCancelOrderByTrackingStatus`, { params: query }
    );
  };

  //Get Cancel Order By Id
  fetchCancelOrderById = async (
    query
  ) => {
    return await http.get(
      `/api/Order/GetCancelOrderByTrackingStatus`, { params: query }
    );
  };

  //Get Return Order By status
  fetchReturnOrders = async (query) => {
    return await http.get(
      `/api/Order/GetReturnOrderByTrackingStatus`, { params: query }
    );
  };

  getCountOrderStatus = async () => {
    return await http.get("/api/Order/GeCounttOrderStatus");
  };

  //Fetch status wise order list
  sellerStatusWiseOrderList = async (query) => {
    return await http.get('/api/Order/GetSellerOrder', { params: query }
    );
  };

  //Get Seller Order Details Start
  getSellerOrderDetails = async (orderProfileId) => {
    return await http.get(
      `/api/Order/GetSellerOrderDetailsById?orderProfileId=${orderProfileId}`
    );
  };
  //Get Seller Order Details End

  //Get Seller Order Invoice Start
  getSellerOrderInvoice = async (shopWiseOrderNo) => {
    return await http.get(
      `/api/Order/GetShopwiseOrderByStatusWise?shopWiseOrderNo=${shopWiseOrderNo}`
    );
  };
  //Get Seller Order Invoice End

  // Change Multiple Invoice Status Start
  changeMultipleInvoiceStatus = async (invoiceList, fromStatusName, toStatusName) => {
    return await http.post(`/api/Order/ChangeMultipleInvoiceStatus?invoiceList=${invoiceList}&fromStatusName=${fromStatusName}&toStatusName=${toStatusName}`);
  };
  // Change Multiple Invoice Status End
}

export default new orderService();

